import { REDUX_ACTIONS, GAME_ID } from '../../data/constants';

export const initState = {
  isOnboarded: false,
  lastLevelUnlocked: 0,
};

const screenReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        isOnboarded: true,
      };

    case REDUX_ACTIONS.UNLOCK_LEVEL:
      return {
        ...state,
        lastLevelUnlocked: payload,
      };

    default:
      return state;
  }
};

export default screenReducer;
